var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFFacebookColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.9997C20 17.0501 16.2562 21.2253 11.3926 21.9028C10.9379 21.9659 10.4726 21.9988 10.0004 21.9988C9.45521 21.9988 8.91988 21.9553 8.39856 21.8713C3.63662 21.1047 0 16.9765 0 11.9997C0 6.47718 4.47746 2 9.99965 2C15.5218 2 20 6.47718 20 11.9997Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3925 10.0323V12.2107H14.0874L13.6607 15.145H11.3925V21.9056C10.9378 21.9687 10.4725 22.0016 10.0003 22.0016C9.45511 22.0016 8.91978 21.9582 8.39846 21.8741V15.145H5.91309V12.2107H8.39846V9.54538C8.39846 7.89183 9.73889 6.55078 11.3932 6.55078V6.55218C11.3981 6.55218 11.4023 6.55078 11.4073 6.55078H14.0881V9.08855H12.3364C11.8158 9.08855 11.3932 9.51105 11.3932 10.0316L11.3925 10.0323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFFacebookColored);
export default __webpack_public_path__ + "static/media/f-facebook-colored.56da49c8412065f1d43fbbe14628aedf.svg";
export { ForwardRef as ReactComponent };